export const apps = {
  master: 'http://localhost:4200',
  tenant: 'http://localhost:4201',
  student: 'http://localhost:4202',
};
